var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2713_111420)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#1B6BC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4999 10C19.1021 10 18.7205 10.158 18.4392 10.4393C18.1579 10.7206 17.9999 11.1022 17.9999 11.5C17.9999 11.8978 18.1579 12.2794 18.4392 12.5607C18.7205 12.842 19.1021 13 19.4999 13C19.8977 13 20.2792 12.842 20.5605 12.5607C20.8418 12.2794 20.9999 11.8978 20.9999 11.5C20.9999 11.1022 20.8418 10.7206 20.5605 10.4393C20.2792 10.158 19.8977 10 19.4999 10ZM19.1399 14.77C17.9499 14.87 14.6999 17.46 14.6999 17.46C14.4999 17.61 14.5599 17.6 14.7199 17.88C14.8799 18.15 14.8599 18.17 15.0499 18.04C15.2499 17.91 15.5799 17.7 16.1299 17.36C18.2499 16 16.4699 19.14 15.5599 24.43C15.1999 27.05 17.5599 25.7 18.1699 25.3C18.7699 24.91 20.3799 23.8 20.5399 23.69C20.7599 23.54 20.5999 23.42 20.4299 23.17C20.3099 23 20.1899 23.12 20.1899 23.12C19.5399 23.55 18.3499 24.45 18.1899 23.88C17.9999 23.31 19.2199 19.4 19.8899 16.71C19.9999 16.07 20.2999 14.67 19.1399 14.77Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2713_111420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationInfo);
export default __webpack_public_path__ + "static/media/notificationInfo.412acb2b5497820907dc8a12824716cc.svg";
export { ForwardRef as ReactComponent };